import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 9.333h-.667V4.667a2 2 0 0 0-2-2H4.667a2 2 0 0 0-2 2v4.666H2a.667.667 0 0 0-.667.667v1.333a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V10A.666.666 0 0 0 14 9.333M4 4.667A.667.667 0 0 1 4.667 4h6.666a.667.667 0 0 1 .667.667v4.666H4zm9.333 6.666a.667.667 0 0 1-.666.667H3.333a.667.667 0 0 1-.666-.667v-.666h10.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })